if (!customElements.get('scx-lightbox')) {
  class ScxLightbox extends HTMLElement {
    constructor() {
      super();
      this.backdrop = this.querySelector('[data-role="backdrop"]');
    }

    connectedCallback() {
    if (this.backdrop) {
      this.backdrop.addEventListener("click", this.close.bind(this));
    }

    // Optional: ESC to close
    document.addEventListener("keydown", this.handleKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.handleKeydown);
  }

  handleKeydown = (e) => {
    if (e.key === "Escape") {
      this.close();
    }
  };

  open() {
    this.setAttribute("open", "");
  }

  close() {
    this.removeAttribute("open");
    document.body.classList.remove("drawer-container");
  }
  }

  customElements.define("scx-lightbox", ScxLightbox);
}
